import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'formatdate',
})
export class FormatDatePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    if (value) {
      return new DatePipe('en-GB').transform(value, 'dd/MM/yyyy - HH:mm');
    }
    return value;
  }
}
